/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { CampaignMain, RecommendationsFloatingSideBar, ErrorComponent } from 'components';
import { useParams } from 'react-router-dom';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import Loader from 'components/common/loader/Loader';
import * as S from './EditCampaign.styled';
import { campaignEnvironment } from 'constants';
import { addUserAgentsOSNameListField } from 'utils';
import { select_current_campaign_obj } from 'store/selectors';
import { creativesActions, generalActions } from 'store/actions';
import {
  //updateRecievedTargetingLocations,
  add_tmp_id_to_all_data_put_to_store,
} from 'utils';
import { cloneDeep } from 'lodash-es';
import uuid from 'react-uuid';
import { NEW_CAMP_STAB_DEFAULT_CREATIVE, NEW_CAMP_STAB_DEFAULT_TRACKING } from 'constants';

const EditCampaignPage = () => {
  const { cmp_id } = useParams();

  const {
    data: campaignData,
    isFetching: isFetchingCampData,
    isError: isErrorCampData,
    isSuccess: isSuccessCampData,
    isLoading: isLoadingCampData,
  } = saveCampaignServiceAPI.useGetCampaignDataByIdQuery(cmp_id);

  const {
    data: creativesAndTrackingData,
    isSuccess: isSuccessCreatAdnTrack,
    isFetching: isFetchingCreatAdnTrack,
    isError: isErrorCreatAdnTrack,
    isLoading: isLoadingCreatAdnTrack,
  } = saveCampaignServiceAPI.useGetCreativesAndTrackingDataQuery(
    {
      cm_id: cmp_id,
      pba_id: campaignData?.currentCampaignObj?.app,
    },
    { skip: Boolean(!campaignData?.currentCampaignObj?.app) },
  );

  const {
    data: creativeListData,
    isSuccess: isSuccessCreativeList,
    isFetching: isFetchingCreativeList,
    isError: isErrorCreativeList,
    isLoading: isLoadingCreativeList,
  } = saveCampaignServiceAPI.useGetCreativesListQuery({
    creativesCampaignId: cmp_id,
  });

  const dispatch = useDispatch();
  const currentCampaignObj = useSelector(select_current_campaign_obj);
  const creativesTracking = useSelector(
    (state) => state?.creatives?.creativeAndTrackingData?.creativesTracking,
  );

  const newCampaignData = useMemo(() => addUserAgentsOSNameListField(campaignData), [campaignData]);

  useEffect(() => {
    if (
      isSuccessCreatAdnTrack &&
      creativesAndTrackingData &&
      creativeListData &&
      isSuccessCreativeList
    ) {
      if (creativeListData) {
        if (creativeListData.length === 0) {
          const newTmpCreativeId = uuid();
          let newCreativeListData = [];
          let newTmpCreative = cloneDeep(NEW_CAMP_STAB_DEFAULT_CREATIVE);
          newTmpCreative.bn_bannerid = newTmpCreativeId;
          newTmpCreative.tmp_id = newTmpCreativeId;
          newTmpCreative.title =
            creativesAndTrackingData?.app_name_full ||
            creativesAndTrackingData?.app_name ||
            'Add Title';
          newTmpCreative.name = 'Add Name';
          if (currentCampaignObj.reEngageGoal) {
            newTmpCreative.appDescription_existing_users = 'Add Message';
          }
          if (currentCampaignObj.acquireNewUserGoal) {
            newTmpCreative.appDescription_new_users = 'Add Message';
          }
          newTmpCreative.status = 0;
          newCreativeListData.push(newTmpCreative);
          const newTrackingforDefaultItem = cloneDeep(NEW_CAMP_STAB_DEFAULT_TRACKING);
          newTrackingforDefaultItem.tmp_id = newTmpCreativeId;
          newTrackingforDefaultItem.bn_bannerid = newTmpCreativeId;
          add_tmp_id_to_all_data_put_to_store(
            creativesAndTrackingData,
            newCreativeListData,
            dispatch,
          );
          dispatch(creativesActions.addTrackingDataForCreative(newTrackingforDefaultItem));
          return;
        }
      }
      add_tmp_id_to_all_data_put_to_store(creativesAndTrackingData, creativeListData, dispatch);
    }
  }, [isSuccessCreatAdnTrack, creativesAndTrackingData, creativeListData, isSuccessCreativeList]);

  useEffect(() => {
    if (!isFetchingCampData && campaignData) {
      dispatch(generalActions.setCampaignDataForID(newCampaignData));

      //updateRecievedTargetingLocations(newCampaignData?.selected_locations);
    }
  }, [campaignData, isFetchingCampData]);

  const loaderFlag = useMemo(() => {
    const creativeListLoader =
      (!isSuccessCreativeList && !isErrorCreativeList) || isFetchingCreativeList;
    const campaignDataLoader = (!isSuccessCampData && !isErrorCampData) || isFetchingCampData;
    const creatAdnTrackLoader =
      (!isSuccessCreatAdnTrack && !isErrorCreatAdnTrack) || isFetchingCreatAdnTrack;
    return campaignDataLoader || creatAdnTrackLoader || creativeListLoader;
  }, [
    isSuccessCampData,
    isErrorCampData,
    isFetchingCampData,
    isSuccessCreatAdnTrack,
    isFetchingCreatAdnTrack,
    isErrorCreatAdnTrack,
    isSuccessCreativeList,
    isFetchingCreativeList,
    isErrorCreativeList,
  ]);

  useEffect(() => {
    dispatch(generalActions.setCampaignEnvironment(campaignEnvironment.edit));
  }, []);

  const showLoader = useMemo(() => {
    if (isLoadingCreativeList || isLoadingCreatAdnTrack || isLoadingCampData) return true;
    return false;
  }, [isLoadingCreativeList, isLoadingCreatAdnTrack, isLoadingCampData]);

  return (
    <>
      {(isErrorCampData || isErrorCreatAdnTrack || isErrorCreativeList) && <ErrorComponent />}
      {showLoader && <Loader.Global delay={1} />}
      {currentCampaignObj !== undefined && creativesTracking !== undefined && !showLoader && (
        <>
          <S.PageMainHeader>Edit Campaign</S.PageMainHeader>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '964px 200px',
              gap: 4,
              margin: 'auto',
              marginBottom: '50px',
              width: '964px',
              gridTemplateRows: 'auto',
              gridTemplateAreas: `"main sidebar"`,
            }}
          >
            <Box sx={{ gridArea: 'main' }}>
              <CampaignMain environment={campaignEnvironment.edit} />
            </Box>
            <Box sx={{ gridArea: 'sidebar' }}>{/* <RecommendationsFloatingSideBar /> */}</Box>
          </Box>
        </>
      )}
    </>
  );
};

export default EditCampaignPage;
